import EventHandler from '@pixelunion/events';
import CardsPlayer from './CardsPlayer';

export default class ProductCards {
  constructor(options) {
    this.el = options.el || null;
    this.defaultCard = this.el.querySelector('[data-product-card-media-selected]');
    this.pagination = options.pagination;
    this.mediaManager = options.mediaManager;
    this.paginationDots = this.pagination.querySelectorAll('[data-product-card-pagination-id]');
    this.viewInYourSpace = options.viewInYourSpace;
    this.selectedPagination = this.pagination.querySelector('[data-product-card-pagination-selected="true"]');

    if (!this.el) {
      return console.warn('Unable to initiate ProductCards.js');
    }

    this.events = new EventHandler();

    this.cardsPlayer = new CardsPlayer(this.el, {
      onCardChange: figure => {
        this.mediaManager.onMediaSelect(figure);
        this._selectPaginationByFigure(figure);
        this._updateViewInYourSpace(figure);
      },
    });

    this.mediaManager.cardsPlayer = this.cardsPlayer;

    if (this.defaultCard) {
      this.switchImage(parseInt(this.defaultCard.dataset.cardsPlayerCard, 10))
    }

    this.events.register(this.pagination.querySelector('[data-product-card-pagination-next]'), 'click', () => this._onNextClick());
  }

  switchImage(id) {
    this.cardsPlayer.drawToCardIndex(this._getCardOffsetByMediaId(id));
  }

  destroy() {
    this.cardsPlayer.destroy();
    this.events.unregisterAll();
  }

  _updateViewInYourSpace(figure) {
    if (!this.viewInYourSpace) return;

    let newModel = this.el.dataset.defaultModel;
    if (figure.dataset.mediaType === 'model') {
      newModel = figure.dataset.cardsPlayerCard;
    }
    this.viewInYourSpace.dataset.shopifyModel3dId = newModel;
  }

  _selectPaginationByFigure(figure) {
    const id = figure.dataset.cardsPlayerCard;
    const newSelectedPagination = this.pagination.querySelector(`[data-product-card-pagination-id="${id}"]`);

    if (!newSelectedPagination) return;

    this.selectedPagination.dataset.productCardPaginationSelected = 'false'
    newSelectedPagination.dataset.productCardPaginationSelected = 'true';
    this.selectedPagination = newSelectedPagination;
  }

  _getCardOffsetByMediaId(id) {
    const figures = this.el.querySelectorAll('[data-cards-player-card]');
    const figure = this.el.querySelector(`[data-cards-player-card="${id}"]`);
    return Array.prototype.indexOf.call(figures, figure);
  }

  _onNextClick() {
    this.cardsPlayer.drawToCardIndex(1);
  }
}
